
import {catchError} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ExceptionService, PaginatedList, UtilsService } from '../../xform-compat';
import { RmsBasicCrudService } from '../components/rms-basic-crud.service';
import { Attachment, CompanyAttachments } from '../../shared/models';

@Injectable({
  providedIn: 'root'
})
export class IndicationAttachmentsService extends RmsBasicCrudService<any> {

  constructor(
    http: HttpClient,
    utilsService: UtilsService,
    exceptionService: ExceptionService
  ) {
    super(http, utilsService, exceptionService);
  }

  /**
   * Gets the list of attachments for an space
   * @param {number} spaceId
   * @param {number} pagesize
   * @param page
   * @returns {Observable<PaginatedList<CompanyAttachments>>}
   */
  public getAttachmentsList (spaceId: number, pagesize: number, page = 0): Observable<PaginatedList<Attachment>> {
    return super.getData(`/api/rms/spaces/${spaceId}/attachments?extrafield=createdBy&pagesize=${pagesize}&page=${page}&sort=created&direction=DESC`);
  }

  /**
   * Gets the list of attachments for an space
   * @param indicationsId
   * @param {number} pagesize
   * @param page
   * @returns {Observable<PaginatedList<CompanyAttachments>>}
   */
  public getAttachmentsListIndications (indicationsId: number, pagesize: number, page = 0): Observable<PaginatedList<Attachment>> {
    return super
      .getData(
        `/api/rms/indications/${indicationsId}/attachments?extrafield=createdBy&pagesize=${pagesize}&page=${page}&sort=created&direction=DESC`
      );
  }

  /**
   * Downloads an attachment
   * @param {CompanyAttachments} item
   * @returns {Observable<Blob>}
   */
  public downloadFile (item: CompanyAttachments | Attachment | number): Observable<Blob> {
    const headers = new HttpHeaders({'Accept': 'application/octet-stream'});
    const currentId = typeof item === 'number' ? item : item['id'];
    return super
      .getHttp()
      .get(`/api/rms/attachments/${currentId}`, {headers, responseType: 'blob'}).pipe(
      catchError(ex => super.getExceptions().catchBadResponse(ex)));
  }

  /**
   * Uploads a file to the server
   * @param fileToUpload
   */
  public uploadFile (fileToUpload: File): Observable<Attachment> {
    const formData: FormData = new FormData();
    formData.append('file', fileToUpload, fileToUpload.name);
    return super.saveData('/api/rms/attachments', formData);
  }
}
